import axios from 'axios'

const origin = (process.env.REACT_APP_API_BASE || 'https://signage-backend-aird.onrender.com').replace(/\/$/, '')

export const SOCKET_URL = origin
export const API_BASE = `${origin}/api`

const api = axios.create({ baseURL: API_BASE })

api.interceptors.request.use((config) => {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('adminToken') : null
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

// Auto-logout on 401 — token expired or invalid
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('adminToken')
      window.location.reload()
    }
    return Promise.reject(err)
  }
)

export default api
